  /*
  function randomId() {
    return String(Math.floor(1e12 + Math.random() * 9e12));
  }
  async function searchBloomreach({ query, rows = 10, start = 0 } = {}) {
    const params = new URLSearchParams({
      account_id: '8258',
      auth_key: 'hdrkqdeih5uyrcu6',
      domain_key: 'amiri',
      request_id: randomId(),
      // _br_uid_2: 'uid=7797686432023:v=11.5:ts=1428617911187:hc=55',
      ref_url: window.location.href,
      url: window.location.href,
      request_type: 'search',
      search_type: 'keyword',
      q: query,
      //fl: 'pid,title,brand,price,sale_price,thumb_image,url,description,tags,handle',
      fl: 'pid,title,tags,url',
      rows: String(rows),
      start: String(start),
    });

    const response = await fetch(`http://core.dxpapi.com/api/v1/core/?${params}`);

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }

  // Usage

  async function initSearchTest() {
    console.log('init search test');
    const results = await searchBloomreach({ query: 'dresses', rows: 10, start: 0 });
    console.log('br results', results);
  }
    */
//initSearchTest();

/*
function randomId() {
  return String(Math.floor(1e12 + Math.random() * 9e12));
}

async function searchBloomreach({ query, rows = 10, start = 0 } = {}) {
  const params = new URLSearchParams({
    account_id: '8258',
    auth_key: 'hdrkqdeih5uyrcu6',
    domain_key: 'amiri',
    request_id: randomId(),
    // _br_uid_2: 'uid=7797686432023:v=11.5:ts=1428617911187:hc=55',
    //ref_url: window.location.href,
    url: window.location.href,
    request_type: 'search',
    search_type: 'category',
    // search_type: 'keyword',
    q: query,
    //fl: 'pid,title,brand,price,sale_price,thumb_image,url,description,tags,handle',
    fl: 'pid,title,tags,url,tags,price',
    rows: String(rows),
    start: String(start),
    sort: 'price desc'
  });

  const response = await fetch(`http://core.dxpapi.com/api/v1/core/?${params}`);

  if (!response.ok) {
    throw new Error(`Request failed: ${response.status} ${response.statusText}`);
  }

  return response.json();
}
  */


async function initSearchTest() {
  console.log('init search test');
  //const results = await searchBloomreach({ query: 'accessories', rows: 10, start: 0 });
  const results = await searchBloomreach({ query: '136823996481', rows: 10, start: 0 });
  console.log('br results', results);
}

initSearchTest();


(()=>{
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  getBloomreachSearchResults(params.q);

  function getBloomreachSearchResults(searchTerm) {

    function randomId() {
      return String(Math.floor(1e12 + Math.random() * 9e12));
    }

    function getCookie(key) {
      const cookies = document.cookie.split('; ');
      const cookie = cookies.find(c => c.startsWith(key + '='));
      return cookie ? cookie.split('=')[1] : null;
    }

    let _br_uid_2 = getCookie('_br_uid_2');

    if (_br_uid_2) {
      _br_uid_2 = decodeURIComponent(_br_uid_2);
    } else {
      _br_uid_2 = '';
    }


    //const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    
    const params = new URLSearchParams({
      account_id: '8258',
      auth_key: 'hdrkqdeih5uyrcu6',
      domain_key: 'amiri',
      request_id: randomId(),
      _br_uid_2: _br_uid_2,
      url: window.location.href,
      request_type: 'search',
      search_type: 'keyword',
      q: searchTerm,
      fl: 'pid,title,url,tags',
      rows: 100,
      start: 0,
    });

    fetch(`http://core.dxpapi.com/api/v1/core/?${params}`)
    .then((res) => res.json())
    .then((result) => {
      console.log('bloomreach result')
      console.log(result)
      renderBloomreachSearchResults(result.response.docs, searchTerm, result.response.numFound)
      
    })
  }

  function renderBloomreachSearchResults (hits, searchTerm, total) {
    //console.log('hits')
    //console.log(hits)

    let html = ``;
    const normalize = str => str.toLowerCase().replace(/[\u2018\u2019\u02BC]/g, "'").replace("'","");

    let mensHits   = hits.filter(hit => !hasTag('womenswear', hit) && !hasTag('kidswear', hit) && !tagsInclude('kids', hit));
    let womensHits = hits.filter(hit => hasTag('womenswear', hit) && !hasTag('kids', hit));
    let kidsHits   = hits.filter(hit => hasTag('kidswear', hit) || tagsInclude('kids', hit));

    function hasTag(tag, hit){
      return hit.tags.some(t => normalize(t) == normalize(tag))
    }

    function tagsInclude(tag, hit){
      return hit.tags.some(t => normalize(t).includes(normalize(tag)))
    }

    //console.log('mensHits', mensHits)
    //console.log('womensHits', womensHits)
    //console.log('kidsHits', kidsHits)

    if(mensHits.length > 0){
      html += renderSection(mensHits, 'MEN');
    }
    if(womensHits.length > 0){
      html += renderSection(womensHits, 'WOMEN');
    }
    if(kidsHits.length > 0){
      html += renderSection(kidsHits, 'KIDS');
    }
    

    document.getElementsByClassName('template-search__results-container')[0].innerHTML = html;

    let resultsMessage = `${total} results found for "${searchTerm}"`;


    if(total == 0){
      resultsMessage = `no results found for "${searchTerm}"`;
    }

    document.getElementsByClassName('template-search__count')[0].innerHTML = resultsMessage;
    addMediaScrollListeners();

    // render product cards in each section 
    hits.forEach((hit, i) => {
      getProductCardHTMLByHandle(hit.url.split('/products/')[1], hit.pid, i)
    });

    function getProductCardHTMLByHandle(handle, pid, position) {
      //console.log('handle', handle)
      let url = `${window.Shopify.routes.root}products/${handle}?view=productcard`;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          if (responseText.indexOf('404 Not Found') == -1) {
            document.getElementById(`pid-${pid}`).innerHTML = html;
          } 
        });
    }
  }

  function renderSection (hits, title) {
    let html = `<div class="flex flex--column flex--one-half">
      <h2 class="visually-hidden">Results for ${title}</h2>
      <ul class="collection__grid list-unstyled" role="list">`;

    hits.forEach(hit => {
      // product card
      html += `<li class="grid__item" id="pid-${hit.pid}"></li>`;
    });

    html += `</ul>
      <div class="results-heading h4 text-center" aria-label="${hits.length} results for ${title}">
        ${title} \ ${hits.length}
      </div>
    </div>`

    return html;
  }

  
})();
